import { name, version } from '../../../../package.json';
export const environment = {
  production: true,
  name,
  version,
  newVersion: '0.7.0',
  visibleCharacters: 7,
  packageConfigurations: {
    extendedZoneCharge: {
      dhl: 190,
      estafeta: 110,
      fedex: 170,
      redpack: 150,
      paqueteexpress: 160
    },
    currency: {
      code: 'MXN',
      symbol: '$'
    }
  },
  apis: {
    extendedZoneNonOfficial: 'https://extendedzonemexico-proxytest.herokuapp.com/extendedZone',
    integrations: 'https://us-central1-ezclo-functions.cloudfunctions.net/integrations/api'
  },
  hereApiKey: 'FANGgX1zCsmlD9iCm9l53KEqLSHnOZ3Vnl-Q5wuzeUk',
  mailerToken: 'vOwTbtw7UtRz8rsCsjDo',
  firebaseConfig: {
    apiKey: 'AIzaSyAHbWCkXHpvY13R7gVlXD0kmgesCV-LGoc',
    authDomain: 'ezclo-core.firebaseapp.com',
    databaseURL: 'https://ezclo-core.firebaseio.com',
    projectId: 'ezclo-core',
    messagingSenderId: '612664166402',
    appId: '1:612664166402:web:33b7ccf0fa7a0855d73f1b',
    measurementId: 'G-VKJ8ZR2J4F'
  },
  companyDocId: 'pGKKZstzoJyAZC5kxvO5',
  contact: {
    name: 'Ezclo',
    phone: '3325652123',
    email: 'enviojabino@gmail.com',
    title: 'Guías electrónicas y mensajería!',
    message: 'Contáctanos',
    phoneLink: '3325652123',
    whatsapp: '3325652123',
    whatsappLink: '3325652123'
  },
  debug: false
};
